module.exports = __webpack_public_path__ + "static/media/ELO.86c10b7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ELO.svg
// module id = 87
// module chunks = 0